<span class="shrink-0 text-xs font-medium text-neutral-gray40">{{ label | translate }}</span>
<span class="min-w-0 break-words text-right text-sm text-neutral-gray70"><ng-content></ng-content></span>
